import { defineComponent as _defineComponent } from 'vue'
import { useJobsSearch } from '@/components/jobs/search'
import { computed, Ref, UnwrapNestedRefs } from 'vue'
import { SearchJobsQuery } from '@/components/jobs/query'

type MaybeRef<T> = Ref<T> | T


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSearchPagination',
  props: {
    query: null,
    currentPage: null,
    updatePage: null
  },
  setup(__props: any) {

const props = __props as {
  query: MaybeRef<UnwrapNestedRefs<SearchJobsQuery>>
  currentPage: number
  updatePage: (page: number) => void
}



const { hasNextPage, isFetching } = useJobsSearch(props.query)

const previousButtonEnabled = computed<boolean>(() => {
  return props.currentPage > 1
})

const nextButtonEnabled = computed<boolean>(
  () => !!hasNextPage.value && !isFetching.value
)

function goToPreviousPage() {
  if (props.currentPage > 1) props.updatePage(props.currentPage - 1)
}

function goToNextPage() {
  if (hasNextPage) props.updatePage(props.currentPage + 1)
}

return { __sfc: true,props, hasNextPage, isFetching, previousButtonEnabled, nextButtonEnabled, goToPreviousPage, goToNextPage }
}

})